import { IPOServices } from "../../services/trading-services"
import { APP_SETTING_ACTION as appTypes } from '../../constants/app';
import { SERVICES_RESP as servicesResp } from '../../configurations';

export const IPOActions = {
  getApplicationAction,
  getApplicationStatusEnquiryAction,
  allotmentResultEnquireAction,
  getListedFocusAction,
  getDetailEnquiryAction,
  getApplyResultAction,
  ipoCancelAction,
  ipoAppliedDetailsEnquiryAction,
  ipoModifyAction,
  getQueryIPOInterestRatePlanFeeAction,
}

function getApplicationAction(params, callback) {
  return () => {
    IPOServices.getApplicationService(params, res => {
      callback(res)
    })
  }
}

function getApplicationStatusEnquiryAction(params, callback) {
  return () => {
    IPOServices.getApplicationStatusEnquiryService(params, res => {
      callback(res)
    })
  }
}

function allotmentResultEnquireAction(params, callback) {
  return dispatch => {
    return IPOServices.allotmentResultEnquireService(params, res => {
      if (res.status === servicesResp.STATUS_OK) {
        callback(res.result);
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: res.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
}

function ipoCancelAction(params,callback){
  return dispatch => {
    return IPOServices.ipoCancelService(params, res => {
      callback(res);
    })
  }
}

function getListedFocusAction(params, callback) {
  return dispatch => {
    return IPOServices.getListedFocusService(params, res => {
      if (res.status === servicesResp.STATUS_OK) {
        callback(res.result);
      } else {
        // const toast = {
        //   type: 'error',
        //   autoClose: true,
        //   errorCode: res.status,
        //   isOpen: true
        // }
        // dispatch({
        //   type: appTypes.SHOW_TOAST,
        //   toast: toast
        // })
      }
    })
  }
  return () => {
    IPOServices.getListedFocusService(params, res => {
      callback(res)
    })
  }
}

function getDetailEnquiryAction(params, callback) {
  return () => {
    IPOServices.getDetailEnquiryService(params, res => {
      callback(res)
    })
  }
}

function getApplyResultAction(params, callback) {
  return () => {
    IPOServices.getApplyResultService(params, res => {
      callback(res)
    })
  }
}

function ipoAppliedDetailsEnquiryAction(params, callback) {
  return () => {
    IPOServices.ipoAppliedDetailsEnquiryService(params, res => {
      callback(res)
    })
  }
}

function ipoModifyAction(params, callback) {
  return () => {
    IPOServices.ipoModifyService(params, res => {
      callback(res)
    })
  }
}

function getQueryIPOInterestRatePlanFeeAction(params, callback) {
  return () => {
    IPOServices.getQueryIPOInterestRatePlanFeeService(params, res => {
      callback(res)
    })
  }
}